import { MenuList as ChakraMenuList, forwardRef } from '@chakra-ui/react';
import type { MenuListProps as ChakraMenuListProps } from '@chakra-ui/react';

export type MenuListProps = ChakraMenuListProps;

export const MenuList = forwardRef<ChakraMenuListProps, 'div'>(
  ({ children, ...restProps }, ref) => {
    return (
      <ChakraMenuList
        ref={ref}
        maxHeight="var(--popper-max-height)"
        {...restProps}
      >
        {children}
      </ChakraMenuList>
    );
  },
);
MenuList.displayName = 'MenuList';
